/*
 * Copyright © 2026 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

import { action, computed, makeObservable, observable } from "mobx"

/**
 * The wizard's current screen. There are no per-step URLs (05 §1): the whole
 * flow lives under the single `/schedule/*` route and a refresh restarts safely at
 * the entry step. This store owns only navigation between screens; session and
 * wizard-input state live in their own stores (added in a later phase).
 */
type BookingView = "verify" | "emailEntry" | "account" | "patient" | "consent" | "health" | "time" | "done"

class BookingUiStore {
  private _view: BookingView

  constructor(initialView: BookingView) {
    // Assign before makeObservable so `_view` is an own property under both the
    // CRA build (useDefineForClassFields) and ts-jest, or MobX can't find it.
    this._view = initialView
    makeObservable<BookingUiStore, "_view">(this, {
      _view: observable,
      view: computed,
      goTo: action,
    })
  }

  get view(): BookingView {
    return this._view
  }

  goTo(view: BookingView): void {
    this._view = view
  }
}

export default BookingUiStore
export type { BookingView }
